import * as store from '@/store';
import {ContinueChatData} from '../interface';
import {openPanel} from './panelStatus';
import {SideTabKey} from '@/interface';

const chatButtonClickCallback = (data: ContinueChatData) => {
    // 关闭编辑器的查看大图
    if ((window as any).mpPreviewViewerInstance?.hidden) {
        (window as any).mpPreviewViewerInstance?.hidden?.();
    } else {
        (window as any).mpPreviewViewerInstance?.destroy?.();
    }
    // 点击继续聊天后，打开超级助理
    openPanel({
        tab: SideTabKey.Ai,
        isExternalNotComment: true,
    });
    store.setData(store.KEYS.CONTINUE_CHAT_DATA, data);
    // 工作流要求此方法需要返回 true
    return true;
};

export {chatButtonClickCallback};
